import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../css_global/utils.css.js';
import { ButtonWrapper } from './SubmitButton.css.js';

const addEnabledStyles = e => e.target.classList.add('btn-press', 'selected-element');
const removeEnabledStyles = e => e.target.classList.remove('btn-press', 'selected-element');
const addDisabledStyles = e => e.target.classList.add('disabled-btn-press', 'selected-element');
const removeDisabledStyles = e => e.target.classList.remove('disabled-btn-press', 'selected-element');

const SubmitButton = props => {
  const {
    align,
    buttonText,
    dataCy,
    fontSize,
    handleClick,
    margin,
    name,
    padding,
    processing,
    radius,
    validated,
    width,
  } = props;

  return (
    <ButtonWrapper align={align} margin={margin}>
      <Button
        data-cy={dataCy}
        fontSize={fontSize}
        name={name}
        onClick={handleClick}
        onTouchCancel={validated ? removeEnabledStyles : removeDisabledStyles}
        onTouchEnd={validated ? removeEnabledStyles : removeDisabledStyles}
        onTouchStart={validated ? addEnabledStyles : addDisabledStyles}
        padding={padding}
        processing={processing}
        radius={radius}
        type="submit"
        value={buttonText}
        width={width}
      />
    </ButtonWrapper>
  );
};

SubmitButton.propTypes = {
  align: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  dataCy: PropTypes.string,
  fontSize: PropTypes.string,
  handleClick: PropTypes.func,
  margin: PropTypes.string,
  name: PropTypes.string,
  padding: PropTypes.string,
  processing: PropTypes.bool,
  radius: PropTypes.string,
  validated: PropTypes.bool,
  width: PropTypes.string,
};

export default SubmitButton;
